import {combineReducers} from "redux";
import app from './App/AppReducer';

export default combineReducers({
    app,
})
